import React from 'react';
import { LifeCycleChain } from '../types/api.types';

interface LifeCycleTooltipProps {
  lifeCycle: LifeCycleChain | null;
  isLoading: boolean;
}

const LifeCycleTooltip: React.FC<LifeCycleTooltipProps> = ({ lifeCycle, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-4 max-w-md">
        <div className="text-sm text-gray-500">Chargement...</div>
      </div>
    );
  }

  if (!lifeCycle || !lifeCycle.nodes || lifeCycle.nodes.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-4 max-w-md">
        <div className="text-sm text-gray-500">Aucun cycle de vie défini</div>
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-4 max-w-md">
      <h3 className="font-semibold text-gray-900 mb-2">Historique du cycle de vie</h3>
      <div className="space-y-2">
        {lifeCycle.nodes.map((node, index) => (
          <div key={node.id} className="flex items-center justify-between text-sm">
            <div className="flex items-center space-x-2">
              <div className={`w-2 h-2 rounded-full ${
                node.status === 'Lancement' ? 'bg-blue-500' :
                node.status === 'Croissance' ? 'bg-green-500' :
                node.status === 'Maturité' ? 'bg-yellow-500' :
                node.status === 'Déclin' ? 'bg-orange-500' :
                'bg-red-500'
              }`} />
              <span className="font-medium">{node.status}</span>
            </div>
            <span className="text-gray-500">
              {new Date(node.date).toLocaleDateString('fr-FR')}
            </span>
          </div>
        ))}
      </div>
      <div className="mt-3 pt-2 border-t border-gray-100">
        <div className="text-xs text-gray-500">
          Statut actuel: <span className="font-medium text-gray-900">{lifeCycle.current_status}</span>
        </div>
      </div>
    </div>
  );
};

export default LifeCycleTooltip; 